import IconAttention from '@/assets/icons/ic_logic-g-app_attention.svg'

import { Button } from '../ui/button'
import { Modal, ModalProps } from './Modal'

interface Props extends ModalProps {
  nickname: string
  onOk: () => void
}

export const DeleteGuardianModal = ({ isOpen, nickname, onOk, ...rest }: Props): JSX.Element => {
  return (
    <Modal
      isOpen={isOpen}
      customStyles={{
        content: {
          padding: '48px 35px',
        },
      }}
      {...rest}
    >
      <h3 className="mb-[15px] mt-[10px] text-center text-2xl font-bold tracking-widest text-primary-text">
        本当に削除しますか
      </h3>

      <p className="text-center text-[15px] font-medium tracking-widest text-secondary-text">
        <span>{nickname}</span>
        の登録を削除します。このそうさは取り消せません。
      </p>

      <div className="mt-9 flex justify-center text-[#D7DDF3]">
        <IconAttention width={104} aria-hidden={true} />
      </div>

      <Button className="mt-[88px] w-full" onClick={onOk}>
        削除
      </Button>
    </Modal>
  )
}
